
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/notice-of-privacy-practices",
      function () {
        return require("private-next-pages/notice-of-privacy-practices.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/notice-of-privacy-practices"])
      });
    }
  